const EqualSignCircleIcon = /*#__PURE__*/ [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 9H16M8 15H16", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export { EqualSignCircleIcon as default };
//# sourceMappingURL=EqualSignCircleIcon.js.map
